/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/* @Usage

const timer = new Timer((time) => <code>);

timer.start();

timer.pause();

timer.resume();
*/

class Timer {
  constructor(callback) {
    this.callback = callback;
    this.startTime = null;
    this.totalPausedTime = 0;
    this.paused = false;
    this.intervalId = null;
    this.pauseStartTime = 0;
  }
  start() {
    this.startTime = Date.now();
    this.intervalId = window.setInterval(() => {
      if (!this.paused) {
        const elapsed = Date.now() - this.startTime - this.totalPausedTime;
        this.callback(elapsed);
      }
    }, 1000);
  }
  pause() {
    if (!this.paused) {
      this.paused = true;
      this.pauseStartTime = Date.now();
    }
  }
  resume() {
    if (this.paused) {
      this.paused = false;
      this.totalPausedTime += Date.now() - this.pauseStartTime;
    }
  }
  stop() {
    window.clearInterval(this.intervalId);
    this.intervalId = null;
    this.startTime = null;
    this.totalPausedTime = 0;
    this.paused = false;
    this.pauseStartTime = 0;
  }
}
export default Timer;